module.exports = __webpack_public_path__ + "img/Powered-by-FAC.d9c383db.jpg";